'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Avatar = function Avatar(props) {
  var _classnames;

  var avatarClass = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, props.className, props.className !== undefined), _defineProperty(_classnames, _styles2.default['avatar__image--small'], props.image && props.size === 'small'), _defineProperty(_classnames, _styles2.default['avatar__image--medium'], props.image && props.size === 'medium'), _defineProperty(_classnames, _styles2.default['avatar__image--large'], props.image && props.size === 'large'), _defineProperty(_classnames, _styles2.default['avatar__image--x-large'], props.image && props.size === 'x-large'), _defineProperty(_classnames, _styles2.default['avatar__text--small'], !props.image && props.size === 'small'), _defineProperty(_classnames, _styles2.default['avatar__text--medium'], !props.image && props.size === 'medium'), _defineProperty(_classnames, _styles2.default['avatar__text--large'], !props.image && props.size === 'large'), _defineProperty(_classnames, _styles2.default['avatar__text--x-large'], !props.image && props.size === 'x-large'), _classnames));

  var profilePic = props.image ? _react2.default.createElement('img', { className: avatarClass, src: props.image }) : _react2.default.createElement(
    'span',
    { className: avatarClass },
    props.initials
  );

  return profilePic;
};

Avatar.propTypes = {
  /**
   * Url of the avatar image
   */
  image: _react.PropTypes.string,
  /**
   * Initials to use when image is not available
   */
  initials: _react.PropTypes.string.isRequired,
  /**
   * Size of the avatar
   */
  size: _react.PropTypes.oneOf(['small', 'medium', 'large', 'x-large']),
  /**
   * Custom class name
   */
  className: _react.PropTypes.string
};

exports.default = Avatar;